import React from 'react';
import {Newsletter} from './Newsletter';
import {AddTrials} from './AddTrials';
import {SurveyQuestions} from './SurveyQuestions';
import BulkUploads from "../BulkUploads";
import UserManagement from "../UserManagement";
import UserActivity from "./UserActivity";

export const NonTable = props => {
  let component;
  switch(props.type) {
    case 'addTrials':
    component =  <AddTrials {...props} context={props.location.state}/>;
    break;
    case 'surveyQuestions':
    component = <SurveyQuestions {...props} />;
    break;
    case 'bulkUploads':
      component = <BulkUploads {...props} nonModal/>;
      break;
    case 'userManagement':
      component = <UserManagement {...props}/>;
      break;
    case 'userActivity':
      component = <UserActivity {...props} />;
      break;
    default: component = <Newsletter context={props.location.state}/>;
  };

  return (
    <div style={{
        height:'100%',
        width:'100%',
        padding: ['addTrials', 'bulkUploads'].includes(props.type) ? '20px 300px 20px 8px' : '10px 0px 10px 0px'
      }}>
      {component}
    </div>
  )
}
